<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>JAVA {{ $t('system.instance') }} {{ item.id }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.alias') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.alias" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.whetherCollected') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-checkbox v-model="item.collecting" dense class="mt-0 pt-0 pb-2"></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="12">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ this.$t('system.description') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.description" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="save" :disabled="disabledSave">{{ $t('common.save') }}</v-btn>
        <v-btn small color="primary" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import editable from './mixins/editable';

export default {
  mixins: [editable],
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
};
</script>

<style scoped>
.empty {
  height: 50px;
}
</style>
